<div class="admin-roles-container" id="admin-roles-container">
    <div class="header">
        <div class="header-text-div">
            <span class="header-text" id="header-text">Admin Roles</span>
        </div>
        <app-button label="Export Report" buttonClass="secondary" (clicked)="openExportModal()"></app-button>
    </div>
    <div class="main">
        <div class="roles-wrapper">
            <mat-accordion class="roles-accordion">
                <mat-expansion-panel *ngFor="let role of roles">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ role.name }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <app-admin-role-table [groupName]="role.name" [users]="userList"></app-admin-role-table>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>
